import { useCallback, useState } from "react";
import Card from "./components/Card";
import * as htmlToImage from "html-to-image";
import download from "downloadjs";

import "./styles.css";

export default function App() {
  const [name, setName]         = useState("Henrique");
  const [date, setDate]         = useState("26-8-2013");
  const [code, setCode]         = useState("BRA");
  const [color1, setColor1]     = useState("#5a31a0");
  const [color2, setColor2]     = useState("#3eda8a");
  const [year, setYear]         = useState(2022);
  const [height, setHeight]     = useState(136);
  const [weight, setWeight]     = useState(28);
  const [position, setPosition] = useState("forward");
  const [photo, setPhoto]       = useState(null);

  const handleDownload = useCallback(async () => {
    const dataUrl = await htmlToImage.toPng(document.getElementById("card"));
    download(dataUrl, `figurinha.png`);
  }, []);

  return (
    <div className="App">
      <Card
        id="card"
        name={name}
        code={code}
        color1={color1}
        color2={color2}
        photo={photo}
        year={year}
        date={date}
        height={height / 100}
        weight={weight}
        position={position}
      />

      <div className="Inputs">
        <div>
          <label>Name: </label>
          <input
            type="text"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </div>
        <div>
          <label>Nascimento: </label>
          <input
            type="text"
            value={date}
            onChange={(e) => {
              setDate(e.target.value);
            }}
          />
        </div>
        <div>
          <label>País (Código): </label>
          <input
            type="text"
            value={code}
            onChange={(e) => {
              setCode(e.target.value);
            }}
          />
        </div>
        <div>
          <label>Ano: </label>
          <input
            type="number"
            value={year}
            onChange={(e) => {
              setYear(e.target.value);
            }}
          />
        </div>
        <div>
          <label>Posição: </label>
          <select
            value={position}
            onChange={(e) => {
              setPosition(e.target.value);
            }}>
            <option value="forward"   >Atacante  </option>
            <option value="midfielder">Meio-campo</option>
            <option value="defender"  >Zagueiro  </option>
            <option value="goalkeeper">Goleiro   </option>
          </select>
        </div>
        <div>
          <label>Altura (cm): </label>
          <input
            type="number"
            min="50"
            max="250"
            step="5"
            value={height}
            onChange={(e) => {
              setHeight(e.target.value);
            }}
          />
        </div>
        <div>
          <label>Peso (kg): </label>
          <input
            type="number"
            min="5"
            max="150"
            value={weight}
            onChange={(e) => {
              setWeight(e.target.value);
            }}
          />
        </div>
        <div>
          <label>Foto: </label>
          <input
            type="file"
            onChange={(e) => {
              if (e.target.files && e.target.files[0]) {
                setPhoto(URL.createObjectURL(e.target.files[0]));
              }
            }}
          />
        </div>
{/*
        <div>
          <label>Cor1: </label>
          <input
            type="color"
            value={color1}
            onChange={(e) => {
              setColor1(e.target.value);
            }}
          />
        </div>
        <div>
          <label>Cor2: </label>
          <input
            type="color"
            value={color2}
            onChange={(e) => {
              setColor2(e.target.value);
            }}
          />
        </div>
        */}

        <button onClick={handleDownload}>Salvar Figurinha</button>
      </div>

      <div
        style={{
          position: "fixed",
          right: 0,
          bottom: 0,
          padding: "6px",
          color: "#91a2b4",
          font: "12px monospace",
          "z-index": 1,
        }}
      >
        v{process.env.REACT_APP_VERSION}
      </div>
    </div>
  );
}
